import { Block, BlockContent, BlockTitle } from '../Block';
import {
  ImageWrapper,
  ImageWrapperSingle,
  SlideTitleWrapper,
  SlideWrapper,
  WrapperSlider
} from './styles';

import Image from 'next/image';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import Text from '../Typography/Text';
import dynamic from 'next/dynamic';
import { translate } from 'react-i18next';
import useWindowDimensions from '../../../hooks/useWindowDimensions';

const SliderComponentWithNoSSR = dynamic(
  import('../../../src/components/Slider2022'),
  {
    // eslint-disable-next-line react/display-name
    loading: () => <div />,
    ssr: false
  }
);

const ImageGallery = ({ data, t, i18n }) => {
  const { width } = useWindowDimensions();
  if (!data?.detail) return null;

  const showControls = useMemo(
    () => {
      if (width >= 1024) {
        if (data.slides.length > 4) {
          return true;
        }
        return false;
      }
      if (width >= 640) {
        if (data.slides.length > 3) {
          return true;
        }
        return false;
      }
      if (data.slides.length > 1) {
        return true;
      }
      return false;
    },
    [width]
  );

  return (
    <Block>
      {data.detail.title && <BlockTitle>{data.detail.title}</BlockTitle>}

      <WrapperSlider>
        {data.slides.length > 1 ? (
          <SliderComponentWithNoSSR
            breakpoints={{
              0: {
                slidesPerView: 1
              },
              640: {
                slidesPerView: data.slides.length >= 3 ? 3 : data.slides.length
              },
              1024: {
                slidesPerView: data.slides.length >= 4 ? 4 : data.slides.length
              }
            }}
            // caption={data.detail.description}
            spaceBetween={20}
            showControls={showControls}
          >
            {data.slides.map(slide => (
              <SlideWrapper key={slide.id}>
                <ImageWrapper>
                  <Image
                    src={slide.image}
                    layout="fill"
                    objectFit="contain"
                    unoptimized
                  />
                </ImageWrapper>

                {/* <SlideTitleWrapper>
                  <Text variant="body2">
                    {i18n.language === 'fr' ? slide.caption_fr : slide.caption_en}
                  </Text>
                </SlideTitleWrapper> */}
              </SlideWrapper>
            ))}
          </SliderComponentWithNoSSR>
        ) : (
          data.slides.map(slide => (
            <SlideWrapper key={slide.id}>
              {slide?.image && (
                <ImageWrapperSingle>
                  <Image
                    src={slide.image}
                    layout="fill"
                    objectFit="contain"
                    unoptimized
                  />
                </ImageWrapperSingle>
              )}
              {/* <SlideTitleWrapper>
                <Text variant="body2">
                  {i18n.language === 'fr' ? slide.caption_fr : slide.caption_en}
                </Text>
              </SlideTitleWrapper> */}
            </SlideWrapper>
          ))
        )}
      </WrapperSlider>
    </Block>
  );
};

ImageGallery.propTypes = {
  title: PropTypes.string
};

export default translate()(ImageGallery);
